// Alderveil cart fix v3
// Only fixes stuck overflow-hidden — does NOT rewire cart icon
// secondary.js handles all cart functionality

(function() {
  function clearStuckOverflow() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    if (document.body.classList.contains('overflow-hidden') && 
        !cartDrawer.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  // Clear on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearStuckOverflow);
  } else {
    clearStuckOverflow();
  }

  // Clear every second as safety net
  setInterval(clearStuckOverflow, 1000);
})();

